module.exports = __webpack_public_path__ + "static/media/hangman02.794f5d62.svg";